"use strict";

var _interopRequireDefault = require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _createClass2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/createClass.js"));
var _classCallCheck2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/classCallCheck.js"));
var _callSuper2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/callSuper.js"));
var _inherits2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/inherits.js"));
var _tslib = require("tslib");
var _vuePropertyDecorator = require("vue-property-decorator");
var NoData = /*#__PURE__*/function (_Vue) {
  function NoData() {
    (0, _classCallCheck2.default)(this, NoData);
    return (0, _callSuper2.default)(this, NoData, arguments);
  }
  (0, _inherits2.default)(NoData, _Vue);
  return (0, _createClass2.default)(NoData);
}(_vuePropertyDecorator.Vue);
NoData = (0, _tslib.__decorate)([_vuePropertyDecorator.Component], NoData);
var _default = exports.default = NoData;